import { GetDocumentVersionMetadataRequest, GetDocumentVersionsRequest } from '@cs-cms/types';

export const versionsQueryKeys = {
  all: ['versions'] as const,
  getVersions: (dto: GetDocumentVersionsRequest) => [versionsQueryKeys.all, dto.ctName, dto.documentId] as const,
  getVersionMetadata: (dto: GetDocumentVersionMetadataRequest) =>
    [versionsQueryKeys.all, 'metadata', dto.ctName, dto.documentId, dto.versionId] as const
};
